import { Injectable, inject } from '@angular/core';

import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@core/http-legacy';
import type { PlacementWithoutOpening } from '@core/placements-types';

@Injectable({
  providedIn: 'root',
})
export class PlacementsWithoutOpeningsHttpService {
  private readonly httpApi = inject(HttpApiService);

  public fetch$(
    jobId: number,
  ): Observable<{ placements: PlacementWithoutOpening[]; jobId: number }> {
    return this.httpApi.get(`/offers/${jobId}/placements/without_openings`).pipe(
      map(response => ({
        placements: response.placements,
        jobId,
      })),
    );
  }
}
